import { useEffect, useState } from "react";

const MINUTE_MS = 60 * 1000;

/** One shared page clock prevents one interval per Proposal row. */
export function useMinuteNow(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), MINUTE_MS);
    return () => window.clearInterval(timer);
  }, []);

  return now;
}
